import http from "@/http/aisea/axios";
const resource = "/voyage_records";

export default {
  getVesselsAndPointByVesselId(vesselId, params) {
    return http.get(`${resource}/vessels/${vesselId}`, {
      params: params,
    });
  },
  getVesselsAndPoint(params) {
    return http.get(`${resource}/vessels/search`, {
      params: params,
    });
  },
  fetchWakeByVesselId(payload) {
    return http.get(`${resource}/vessels/${payload.vesselId}/wake`, {
      params: {
        started_at: payload.started_at,
        ended_at: payload.ended_at,
        vessel_id: payload.vesselId,
        interval: 20,
      },
    });
  },
};
